export default "__VITE_ASSET__gN9Um2VS__"